/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Timer_Clock_Skew_AdvisoryInputs */



/**
* | output |
* | --- |
* | "Your clock is about {amount} off." |
*
* @param {Timer_Clock_Skew_AdvisoryInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const timer_clock_skew_advisory = /** @type {((inputs: Timer_Clock_Skew_AdvisoryInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_Clock_Skew_AdvisoryInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Votre horloge est décalée d'environ ${i?.amount}.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Su reloj está desfasado unos ${i?.amount}.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Seu relógio está com um desvio de cerca de ${i?.amount}.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Il tuo orologio è sfasato di circa ${i?.amount}.`)
	return /** @type {LocalizedString} */ (`Your clock is about ${i?.amount} off.`)
});